import DetailFormHead from "components/subHead/detailFormHead";
import TableRow from "components/rows/tableRow";
import Cell from "components/rows/cell";
import LodInfRow from "components/rows/lodRow";
import { useTranslation } from "react-i18next";
import { useGetData } from "./service";
import { dateFormat, priceFormat, timeFormat } from "components/utils/comm";
import BaseInfLoaing from "components/detailLoading/baseInf";
import { useEffect, useRef } from "react";

export default function RoomProductDetail() {
  const { t } = useTranslation();

  const { rmPdInf, rmOpNmList, isLoading, isSuccess } = useGetData();
  const today = new Date().toISOString().split("T")[0].replaceAll("-", "");
  const opDescRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (rmOpNmList && opDescRef.current) {
      opDescRef.current.innerHTML = rmOpNmList[0]?.rmOpDesc;
    }
  }, [rmOpNmList]);

  return (
    <>
      <>
        {/* 기본정보 */}
        <DetailFormHead title={t("row_ttl_default")} />
        {(!rmPdInf || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
        )}
        {rmPdInf && (
          <table>
            <tbody>
              <LodInfRow />
              <TableRow title={t("row_ttl_rm_inf")}>
                <ul>
                  <li>
                    <Cell label={t("lbl_rm_nm")} value={rmPdInf?.rmNm} />
                  </li>
                  <li>
                    <Cell label={t("lbl_rm_typ")} value={rmPdInf?.rmTypNm} />
                  </li>
                  <li>
                    <Cell label={t("lbl_rm_olk")} value={rmPdInf?.rmOlkNm} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}
        {/* 옵션정보 */}
        <DetailFormHead title={t("sub_op_inf")} />
        {(!rmPdInf || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_op_inf")} isData={isSuccess} />
        )}
        {rmPdInf && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_rm_op_inf")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_rm_op_nm")}
                      value={rmOpNmList ? rmOpNmList[0].rmOpNm : ""}
                    />
                  </li>
                </ul>
                <ul>
                  <li style={{ width: "100%" }}>
                    <label htmlFor="">{t("lbl_rm_op_desc")}</label>
                    <div
                      ref={opDescRef}
                      className="border-1 w-full h-full flex-1 px-2"
                    ></div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_bed_typ")}
                      value={
                        rmPdInf?.brkfInYn === "Y"
                          ? t("included_y")
                          : t("included_n")
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_lat_out_ti")}
                      value={timeFormat(rmPdInf?.latChkOutTi)}
                    />
                  </li>
                  <li>
                    <Cell label={"특가할인"} value={""} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}
        {/* 상품정보 */}
        <DetailFormHead title={t("sub_ttl_rmpd_inf")} />
        {(!rmPdInf || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_pd")} isData={isSuccess} />
        )}
        {rmPdInf && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_rm_pd")}>
                <ul>
                  <li>
                    <Cell label={t("lbl_rmpd_no")} value={rmPdInf?.rmPdNo} />
                  </li>
                  <li>
                    <Cell label={t("lbl_rmpd_chl")} value={rmPdInf?.lodChlNm} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_dt")}
                      value={dateFormat(rmPdInf?.sellDt)}
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_rmpd_ct")} value={rmPdInf?.rmPdCt} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_price")}
                      value={
                        priceFormat({ price: rmPdInf?.sellPri ?? "" }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_status_cmm")}
                      value={
                        Number(rmPdInf.sellDt) > Number(today)
                          ? rmPdInf.sellYn === "Y"
                            ? t("status_sell_y")
                            : t("status_sell_n")
                          : t("status_sell_end")
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_fst_dtti")}
                      value={dateFormat(rmPdInf?.fstCrtDtti)}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_fst_usid")}
                      value={rmPdInf?.fstCrtUsid}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_lt_dtti")}
                      value={dateFormat(rmPdInf?.ltChDtti)}
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_lt_usid")} value={rmPdInf?.ltChUsid} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}
      </>
    </>
  );
}
